import md5 from '@/script/md5'
import { apiList, $axios } from '@/api'

const MAX_LIFETIME = 30 * 60 * 60 * 1000

const inMemoryCache = {}

export default {
    state: () => ({
        categories: []
    }),
    actions: {
        getAllCategories(_, { addsubcat, criteria }) {
            const hashOfPayload = md5(JSON.stringify(criteria))
            return new Promise((resolve, reject) => {
                if (inMemoryCache[hashOfPayload]) {
                    const cachedValue = inMemoryCache[hashOfPayload]
                    const now = new Date().getTime()
                    const diff = now - cachedValue.req_timestamp
                    if (diff < MAX_LIFETIME) {
                        resolve(cachedValue)
                        return
                    }
                }
                $axios({
                    method: apiList.categories.getAll.method,
                    params: {
                        wsfunction: apiList.categories.getAll.moodle_method
                    },
                    data: {
                        addsubcategories: addsubcat || 0,
                        criteria
                    }
                })
                    .then(resp => {
                        if (resp?.data?.exception) {
                            resolve(resp.data)
                        } else {
                            resp.req_timestamp = new Date().getTime()
                            inMemoryCache[hashOfPayload] = resp.data
                            resolve(resp)
                        }

                    })
                    .catch(err => reject(err))

            })
        },
        getCategoriesByPage(_, { page, addsubcat, criteria }) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.categories.getCategoriesByPage.method,
                    params: {
                        wsfunction: apiList.categories.getCategoriesByPage.moodle_method
                    },
                    data: {
                        page: page,
                        addsubcategories: addsubcat,
                        criteria
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    })
                    .catch(err => reject(err))
            })
        }
    },

    getters: {
        categories: state => state.categories
    }

}
